import { Link } from 'react-router-dom'
import { fbt } from 'fbtee'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { PageLayout } from '@/components/PageLayout'
import { BeaconLogo } from '@/components/BeaconLogo'
import { Button } from '@/components/ui/button'

// Public /beacon page: what people searching for the old name land on (#585).
// Indexable and permanent — the email, store replies and social bios link here.
export default function BeaconRenamePage() {
  useDocumentTitle(fbt('Beacon is now Faro', 'Browser tab title for the page explaining the rename from Beacon to Faro'))

  return (
    <PageLayout>
      <div className="mx-auto flex max-w-md flex-col items-center gap-5 px-4 py-12 text-center">
        <BeaconLogo className="size-20" />
        <h1 className="text-3xl font-bold tracking-tight">
          <fbt desc="Heading of the public page explaining the rename from Beacon to Faro">Beacon is now Faro</fbt>
        </h1>
        <p className="text-muted-foreground">
          <fbt desc="First paragraph of the public page explaining the rename from Beacon to Faro">
            Faro is the festival planner you knew as Beacon: browse lineups, plan with friends and see whose picks
            overlap. Same app, same icon, new name.
          </fbt>
        </p>
        <p className="text-muted-foreground">
          <fbt desc="Second paragraph of the public page explaining the rename from Beacon to Faro">
            Your account, groups, plans and invite links all keep working. Nothing to reinstall. If you search for
            the app, type Faro.
          </fbt>
        </p>
        <Button asChild>
          <Link to="/">
            <fbt desc="Button on the Beacon rename page that opens the app home">Open Faro</fbt>
          </Link>
        </Button>
      </div>
    </PageLayout>
  )
}
